import React, { useState, useContext, useEffect, useRef } from 'react';
import {
  Grid,
  Button,
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Skeleton,
} from '@mui/material';
import { AppContext } from '../../../context/Context';
import { useTranslation } from 'react-i18next';
import BlurTable from '../../../assets/img/blurTable.jpg';

import { SocketContext } from '../../../context/SocketContext';
import toast from 'react-hot-toast';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import '../../../assets/css/buttons.css';

function SellScreenListOKD({ updateAmountShortcut, isTab, isRefill }) {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const loadingTable = Array.from({ length: 12 });

  const {
    updateTicketSelectedKioskOK,
    OKBingoID,
    userSiblings,
    userChildren,
    session,
    operator,
    hall,
    updateUserLogin,
    currentUser,
    ticketsCH,
    userInfo,
    parentInfo,
    ticketsOK,
    updateTicketsOK,
    currentTicketOK,
    updateCurrentTicketOK,
    updateTicketsOKWithNewSaldo,
    isOKBingoEnabled,
    ticketsTempOK,
    updateIsTerminalBusy,
  } = useContext(AppContext);

  const OKBingoIDRef = useRef(OKBingoID);

  const { socket } = useContext(SocketContext);

  useEffect(() => {
    if (!isOKBingoEnabled) {
      return;
    }
    socket.emit('ticketsOK', {
      operator: operator,
      bingoName: hall,
      userID: parentInfo ? parentInfo.id : userInfo.id,
      userInfo: parentInfo ? parentInfo : userInfo,
      session: session,
      action: 'ticketsOK',
      OKBingoID: OKBingoID,
    });
  }, []);

  useEffect(() => {
    if (!isOKBingoEnabled) {
      return;
    }
    if (!ticketsOK || ticketsOK.length === 0) {
      return;
    }
    for (let i = 0; i < ticketsOK.length; i++) {
      if (
        currentTicketOK.okID === ticketsOK[i].okID &&
        ticketsOK[i].amount &&
        !isRefill
      ) {
        updateCurrentTicketOK(ticketsOK[i]);
        updateTicketSelectedKioskOK(ticketsOK[i]);
        updateAmountShortcut(ticketsOK[i].amount);
      }
    }
  }, [ticketsOK]);

  useEffect(() => {
    const handleTicketsOK = (data) => {
      if (data.error) {
        toast.error(t('error.error'));
        return;
      }

      if (!data.ticketsOK) {
        setLoading(false);
      }

      updateTicketsOK(data.ticketsOK);
    };

    const handleBroadcastGetTicketSaldoOK = (data) => {
      if (data.error) {
        toast.error(t('error.error'));
        return;
      }
      if (!data || data.length === 0) {
        return;
      }
      updateTicketsOKWithNewSaldo(data);
      setLoading(false);
      if (currentTicketOK.amount && !isRefill) {
        updateAmountShortcut(currentTicketOK.amount);
      }
    };

    socket.on('broadcastGetTicketSaldoOK', handleBroadcastGetTicketSaldoOK);
    socket.on('ticketsOK', handleTicketsOK);

    return () => {
      socket.off('broadcastGetTicketSaldoOK', handleBroadcastGetTicketSaldoOK);
      socket.off('ticketsOK', handleTicketsOK);
    };
  }, [socket]);

  const sessionRef = useRef(session);
  useEffect(() => {
    sessionRef.current = session;
  }, [session]);

  const activateTicket = (ticket) => {
    console.log('Activating ticket:', ticket);
    updateCurrentTicketOK(ticket);
    updateTicketSelectedKioskOK(ticket);

    if (!isRefill) {
      setTimeout(() => {
        updateAmountShortcut(ticket.amount);
      }, 450);
    }
  };
  const getTerminalNumber = (s) => {
    const m = s.match(/Terminalnr:\s*(\d+)/i);
    return m ? Number(m[1]) : null;
  };

  // === UI only (glass) ===
  const glassBg = 'rgba(255,255,255,0.06)';
  const glassBorder = '1px solid rgba(255,255,255,0.12)';
  const headBg = 'rgba(0,0,0,0.20)';

  const tableContainerSx = {
    flex: 1,
    minHeight: 0,
    height: '100%',
    maxHeight: '100%',
    overflowY: 'auto',
    borderRadius: '18px',
    border: glassBorder,
    background: glassBg,
    boxShadow: 'inset 0 0 0 1px rgba(255,255,255,0.04)',
    scrollbarWidth: 'none',
    '&::-webkit-scrollbar': { display: 'none' },

    '&.MuiPaper-root': { background: 'transparent', boxShadow: 'none' },
    '& .MuiTable-root': { background: 'transparent' },
    '& .MuiTableCell-root': {
      color: 'white',
      borderBottom: '1px solid rgba(255,255,255,0.08)',
      padding: '14px 16px',
      fontSize: '18px',
    },
    '& .MuiTableCell-head': {
      position: 'sticky',
      top: 0,
      zIndex: 2,
      background: headBg,
      backdropFilter: 'blur(10px)',
      WebkitBackdropFilter: 'blur(10px)',
      color: 'rgba(255,255,255,0.82)',
      fontWeight: 900,
      textTransform: 'uppercase',
      letterSpacing: '0.12em',
      fontSize: '15px',
      borderBottom: '1px solid rgba(255,255,255,0.10)',
    },
  };

  const actionBtnSx = {
    height: '44px',
    fontSize: '15px',
    borderRadius: '999px',
    border: '1px solid rgba(255,255,255,0.16)',
    color: 'white',
    fontWeight: 900,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    background: 'rgba(255,255,255,0.06)',
    '&:hover': { background: 'rgba(255,255,255,0.10)' },
  };

  const actionBtnSelectedSx = {
    ...actionBtnSx,
    border: '1px solid rgba(34,197,94,0.35)',
    background: 'rgba(34,197,94,0.10)',
    '&:hover': { background: 'rgba(34,197,94,0.14)' },
  };

  const rowSx = (isSelected, index) => ({
    '&:last-child td, &:last-child th': { border: 0 },
    backgroundColor: isSelected
      ? 'rgba(34,197,94,0.14)'
      : index % 2 === 0
        ? 'rgba(255,255,255,0.03)'
        : 'rgba(255,255,255,0.015)',
    '&:hover td': {
      backgroundColor: isSelected
        ? 'rgba(34,197,94,0.18)'
        : 'rgba(255,255,255,0.05)',
    },
  });

  return (
    <Grid
      item
      xs={12}
      sx={{
        padding: '10px',
        height: '100%',
        minHeight: isTab ? 0 : '555px',
        width: '100%',
        marginTop: '0',
        marginLeft: 0,
        display: 'flex',
        alignItems: 'stretch',
        justifyContent: 'flex-start',
        flexDirection: 'column',
        minHeight: 0,
      }}
    >
      {!isTab && (
        <h2 style={{ textAlign: 'left', width: '100%', margin: '0 0 10px 0' }}>
          {t('sales.payoutTicket')}
        </h2>
      )}

      <Grid
        container
        flexDirection="row"
        sx={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          marginTop: 0,
          marginLeft: 0,
          display: 'flex',
          justifyContent: 'flex-start',
          alignContent: 'stretch',
          alignItems: 'stretch',
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            width: '100%',
            maxWidth: '100% !important',
            flex: 1,
            minHeight: 0,
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          {loading ? (
            <TableContainer component={Paper} sx={tableContainerSx}>
              <Table
                sx={{ color: 'white', background: 'transparent' }}
                stickyHeader
                aria-label="simple table"
              >
                <TableHead sx={{ background: 'transparent' }}>
                  <TableRow>
                    <TableCell align="center">
                      {t('apneBilleter.ticketID')}
                    </TableCell>
                    <TableCell align="center">{t('sales.saldo')}</TableCell>
                    <TableCell align="center">{t('sales.status')}</TableCell>
                    <TableCell align="center"> </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {loadingTable.map((index) => (
                    <TableRow sx={rowSx(false, index)} key={index}>
                      <TableCell component="th" scope="row" align="center">
                        <Skeleton />
                      </TableCell>
                      <TableCell align="center">
                        <Skeleton />
                      </TableCell>
                      <TableCell align="center">
                        <Skeleton />
                      </TableCell>
                      <TableCell align="center">
                        <Skeleton />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            <TableContainer component={Paper} sx={tableContainerSx}>
              <Table
                sx={{ color: 'white', background: 'transparent' }}
                stickyHeader
                aria-label="simple table"
              >
                <TableHead sx={{ background: 'transparent' }}>
                  <TableRow>
                    <TableCell align="center">
                      {t('apneBilleter.ticketID')}
                    </TableCell>
                    <TableCell align="center">{t('sales.saldo')}</TableCell>
                    <TableCell align="center">{t('sales.status')}</TableCell>
                    <TableCell align="center"> </TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {ticketsOK && ticketsOK.length > 0 && (
                    <>
                      {ticketsOK.map((ticket, index) =>
                        ticket.isCashedOut ||
                        ticketsTempOK.some(
                          (ticketTemp) =>
                            ticketTemp.ticketNumber === ticket.okID
                        ) ? null : (
                          <TableRow
                            key={index}
                            sx={rowSx(
                              currentTicketOK?.okID === ticket.okID,
                              index
                            )}
                          >
                            <TableCell
                              component="th"
                              scope="row"
                              align="center"
                              sx={{
                                color:
                                  currentTicketOK?.okID === ticket.okID
                                    ? '#18ff18'
                                    : 'inherit',
                              }}
                            >
                              {ticket.okID}
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color:
                                  currentTicketOK?.okID === ticket.okID
                                    ? '#18ff18'
                                    : 'inherit',
                              }}
                            >
                              {ticket.errorNumber !== '' ? (
                                '-'
                              ) : (
                                <>
                                  {ticket.amount !== undefined &&
                                  ticket.amount !== null
                                    ? ticket.amount
                                    : '-'}
                                </>
                              )}
                            </TableCell>

                            <TableCell
                              align="center"
                              sx={{
                                color:
                                  currentTicketOK?.okID === ticket.okID
                                    ? '#18ff18'
                                    : 'inherit',
                              }}
                            >
                              {ticket.errorNumber === 3 &&
                                ticket.errorDescription ===
                                  'Ticket er allerede lukket' &&
                                t('sales.closed')}

                              {(ticket.errorNumber === 2 &&
                                ticket.errorDescription ===
                                  'Ticket er stengt') ||
                                (ticket.isClosed && t('sales.closed'))}

                              {ticket.errorNumber === 510 &&
                                t('sales.ticketInUse') +
                                  getTerminalNumber(ticket.errorDescription)}

                              {ticket.errorNumber === '' &&
                                ticket.errorDescription === '' &&
                                t('sales.open')}
                            </TableCell>

                            <TableCell align="center">
                              {(ticket.errorNumber === '' ||
                                (String(ticket.errorNumber) === '510' &&
                                  isRefill)) && (
                                <>
                                  {currentTicketOK?.okID !== ticket.okID ? (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      sx={actionBtnSx}
                                      onClick={() => activateTicket(ticket)}
                                    >
                                      {!isRefill
                                        ? t('sales.payout')
                                        : t('sales.refill')}
                                    </Button>
                                  ) : (
                                    <Button
                                      size="small"
                                      variant="outlined"
                                      sx={actionBtnSelectedSx}
                                      onClick={() => activateTicket(ticket)}
                                    >
                                      {t('sales.selected')}
                                    </Button>
                                  )}
                                </>
                              )}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}

export default SellScreenListOKD;
